import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import Company from './Company'

function CompanyContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "Company",
    navSubTitle: "Welcome to ImagesBazaar"
  })

  const handleNavParams = (obj)=>{
    setNavParams({
      ...navParams,
      ...obj
    })
  }

  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <Company handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default CompanyContainer